import { useNavigate, useParams } from "react-static-url-router";
import {
  ResultResponse,
} from "../queries/integrations/back_end";
import Box from "../components/layout/Box";
import Heading from "../components/typography/Heading";
import { Text } from "../components/typography/Text";
import { PieChart, Pie, Cell } from "recharts";
import styled from "styled-components";
import { Equivalents } from "./private/Equivalents";
import { FormEvent, ReactNode, useState } from "react";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { styled as muiStyled } from '@mui/system';
import { FormValues } from "./Form";
import { TypePicker } from "../components/form/TypePicker";
import { Form, Formik } from "formik";
import { images } from "./private/images";
import Image from "../components/primitives/Image";
import Button from "../components/navigation/Button";
import { ChevronLeft, RefreshCw } from "react-feather";
import { FaEarthAmericas, FaGasPump  } from "react-icons/fa6";
import TooltipCustom from "../components/molecules/TooltipCustom";
import AnimatedNumbers from "react-animated-numbers";
import { useEffect } from 'react';

/*
const $style = document.createElement("style");
document.head.appendChild($style);
const randBlue = ~~(Math.random() * 250);
$style.innerHTML = `body { color: rgb(10, 10, ${randBlue}); }`;
*/

const windowWidth = window.innerWidth;
// Example condition based on window width
const shouldDisplayComponent = windowWidth > 900; // Example threshold


const tooltipCo2Content = `
Calculé à partir des données constructeur, de la distance et de la fréquence de votre trajet remplacé par le vélo.
`;
const tooltipCarburantContent = `
Calculé à partir des données constructeur, de la distance et de la fréquence de votre trajet remplacé par le vélo et du prix du carburant (moyenne des 6 derniers mois autour de votre domicile)
`;

const StyledPieChart = styled(Box)`
  position: relative;

  span {
    position: absolute;
    width: 100%;
    height: 100%;
    text-align: center;
    display: flex;
    align-items: center;

    h3 {
      flex-grow: 1;
    }
  }
`;

const CustomToggleButton = muiStyled(ToggleButton)({
  fontFamily: "var(--font-text)",
  textTransform: "none",
  backgroundColor: "var(--color-n-200)",
  color: "var(--color-primary)",
  border: "none",
  borderRadius: "40px !important",
  padding: "0px",
  width: "80px",
  margin: "4px",
  '&:hover': {
    backgroundColor: "var(--color-primary)",
    color: "#fff",
  },
  '&.Mui-selected:hover': {
    backgroundColor: "var(--color-primary)",
    color: "#fff",
  },
  '&.Mui-selected': {
    backgroundColor: "var(--color-primary)",
    color: "#fff",
  },
  '&.Mui-disabled': {
    border: "none",
  }
});

const CustomToggleButtonGroup = muiStyled(ToggleButtonGroup)({
  padding: "0px 0px",
  borderRadius: "50px",
  backgroundColor: "var(--color-n-200)"
});

const LoadedComponent = ({
  parsedFormValues,
  algo_result,
  request_id
}: {
  parsedFormValues: FormValues;
  algo_result: ResultResponse;
  request_id: string;
}) => {
  const navigate = useNavigate();
  const [isMonthly, setIsMonthly] = useState(false);
  const [weeklyComute, setWeeklyComute] = useState(
    parsedFormValues.addresses.weekly_comutes.toString(),
  );
  
  const basePolution =
    (algo_result.pollution_par_mois /
      parsedFormValues.addresses.weekly_comutes) *
    parseInt(weeklyComute);
  const baseSavings =
    (algo_result.economie_par_mois /
      parsedFormValues.addresses.weekly_comutes) *
    parseInt(weeklyComute);

  const polution = isMonthly ? basePolution : basePolution * 12;
  const savings = isMonthly ? baseSavings : baseSavings * 12;

  const Section = ({
    children,
    withGap,
  }: {
    children: ReactNode;
    withGap?: boolean;
  }) => (
    <Box col gap={withGap ? "s" : "no"}>
      {children}
    </Box>
  );
  const Sections = ({ children }: { children: ReactNode }) => (
    <Box col gap="m">
      {children}
    </Box>
  );

  const handleWeeklyComuteChange = (
    event: FormEvent,
    setFieldValue: (a: string, b: string) => void,
  ) => {
    const target = event.target as HTMLInputElement;
    const value = target.value;
    setWeeklyComute(value);
    setFieldValue("weekly_comutes", target.value);
  };

  function retrieveMaxAmount() {
    let parsedVal;
    if (parsedFormValues.subvention.isOfficial === "YES") {
      parsedVal = algo_result.aide_fonctionnaire;
      // parsedVal = 300;
      // parsedVal = parsedFormValues.subvention.maxAmount;
    } else if (parsedFormValues.subvention.isOfficial === "NO" && parsedFormValues.subvention.hasCompanySetUpSubvention === "NO") {
      parsedVal = 0;
    } else {
      parsedVal = parsedFormValues.subvention.maxAmount;
    }
    return parsedVal 
  }

  const maximalConditionalAmount = retrieveMaxAmount();

  useEffect(() => {
    const script = document.createElement('script');
    script.src = "https://tally.so/widgets/embed.js";
    script.async = false;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    }
  }, [algo_result, request_id]);

  const openTallyPopUp = () => {
    type TallyWindow = {
      Tally: unknown
    }
    type Tally = {
      openPopup: (id: string, options: { layout: string, emojiText: string, emojiAnimation: string, hiddenFields: { request_id: string } }) => void
    }
    const tallyWindow = window as typeof window & TallyWindow;
    const tally = tallyWindow.Tally as Tally;
    
    tally.openPopup(
      "mK6eQ7",
      {
        layout: "modal",
        emojiText: "👋",
        emojiAnimation: "wave",
        hiddenFields: {
          request_id: request_id
        }
      }
    )
  }

  return (
    <Box>
      <Heading paddingX="p1" marginT="m1" weight="700" size="h3" marginY="m1">Votre Bilan</Heading>


      {
        
        shouldDisplayComponent ? (
          <Box flex flexRatio={1} gap="no" all="m">
          <Box>
          <Heading weight="700" size="h4" marginY="m1">Vos informations</Heading>
          <Box col border="gradient" rounded >
            <Sections>
              <Section> 
                <Heading weight="900" uppercase="true" size="h5" marginT="m1" paddingX="p1">Votre trajet</Heading>
                <hr style={{ width: "100%", border: "0.5px solid var(--color-n-200)", marginBottom: "0.5rem" }}/>
                <Box col gap="xxxs">
                  <Text styleText="italic" size="s" marginY="m0" color="n-400" paddingX="p1">Domicile</Text>
                  <Text marginY="m0" maxWidth="400" color="n-900" paddingX="p1">{parsedFormValues.addresses.home.label}</Text>
                  <Text styleText="italic" size="s" marginY="m0" color="n-400" paddingX="p1">Lieu de travail</Text>
                  <Text marginY="m0" maxWidth="400" color="n-900" paddingX="p1">{parsedFormValues.addresses.work.label}</Text>
                  <Text styleText="italic" size="s" marginY="m0" color="n-400" paddingX="p1">Fréquence</Text>
                  <Text marginY="m0" color="n-900"  paddingX="p1">
                    Vous effectuez le trajet <span style={{ fontWeight: "900", color: "var(--color-primary)" }}>{weeklyComute} fois</span> par semaine
                  </Text>
                  <Box padding="s">
                    <Formik
                      onSubmit={() => undefined}
                      initialValues={{ weekly_comutes: weeklyComute }}
                    >
                      {({ setFieldValue }) => (
                        <Form
                          onChange={(event) =>
                            handleWeeklyComuteChange(event, setFieldValue)
                          }
                        >
                          <TypePicker.Root fieldName="weekly_comutes">
                            <TypePicker.OptionsGroup direction="row" gap="xxxs">
                              {["1", "2", "3", "4", "5", "6", "7"].map((value) => (
                                <TypePicker.Option roundSmall={true} value={value}>
                                  {value}
                                </TypePicker.Option>
                              ))}
                            </TypePicker.OptionsGroup>
                          </TypePicker.Root>
                        </Form>
                      )}
                    </Formik>
                  </Box>
                </Box>
              </Section>
              <Section>
                <Heading weight="900" uppercase="true" size="h5" paddingX="p1">Votre véhicule</Heading>
                <hr style={{ width: "100%", border: "0.5px solid var(--color-n-200)", marginBottom: "0.5rem" }}/>
                <Box col gap="xxxs">
                  <Text styleText="italic" size="s" marginY="m0" color="n-400" paddingX="p1">Marque</Text>
                  <Text marginY="m0" color="n-900" paddingX="p1">{parsedFormValues.vehicle.brand}</Text>
                  <Text styleText="italic" size="s" marginY="m0" color="n-400" paddingX="p1">Modèle spécifique</Text>
                  <Text marginY="m0" color="n-900" paddingX="p1">{parsedFormValues.vehicle.model}</Text>
                  <Text styleText="italic" size="s" marginY="m0" color="n-400" paddingX="p1">Type de moteur</Text>
                  <Text marginY="m0" color="n-900" paddingX="p1">{parsedFormValues.vehicle.fuel}</Text>
                  <Text styleText="italic" size="s" marginY="m0" color="n-400" paddingX="p1">Année de mise en circulation</Text>
                    {parsedFormValues.vehicle.registrationYear !== "unknown" && (
                      <Text marginY="m0" color="n-900" paddingX="p1">{parsedFormValues.vehicle.registrationYear}</Text>
                    )}
                </Box>
              </Section>
              <Section>
                <Heading weight="900" uppercase="true" size="h5" paddingX="p1">Forfait Mobilité Durable</Heading>
                <hr style={{ width: "100%", border: "0.5px solid var(--color-n-200)", marginBottom: "0.5rem" }}/>
                <Box col gap="xxxs" padding={{ block_end: "s"}}>
                  
                  <Box padding="xs" flex alignItems="center" >
                    <CustomToggleButtonGroup
                      value={true}
                      exclusive
                      size="small"
                      onChange={() => ""}
                      aria-label="text alignment"
                    >
                      <CustomToggleButton 
                        value={maximalConditionalAmount > 0 ? true : false} 
                        disabled
                      >
                        <span>OUI</span>
                      </CustomToggleButton>
                      
                      <CustomToggleButton 
                        value={(maximalConditionalAmount === undefined || maximalConditionalAmount === 0) ? true : false}
                        disabled
                      >
                        <span>NON</span>
                      </CustomToggleButton>

                    </CustomToggleButtonGroup>
                  </Box>

                  <Text styleText="italic" size="s" marginY="m0" color="n-400" paddingX="p1">Montant maximal du forfait</Text>
                  <Text marginY="m0" color="n-900" paddingX="p1">{maximalConditionalAmount}€</Text>
                  
                  {/*

                  <Text style="italic" size="s" marginY="m0" color="n-400" paddingX="p1">Montant minimum du forfait</Text>
                  <Text marginY="m0" color="n-900" paddingX="p1">{algo_result.aide_totale}€</Text>
                  
                  */}
                  
                
                </Box>
              </Section>
            </Sections>
          </Box>
          <Box 
            flex 
            col
            justifyContent="start" 
            alignItems="start" 
            padding={{block_start: "s"}} 
            gap="xxxs"
          >
            <div 
              style={{ display: "flex", gap: "6px" ,alignItems: "center", cursor: "pointer", fontFamily: "var(--font-text)" }}
              onClick={() => {
                const stringifiedValues = JSON.stringify(parsedFormValues);
                const params = new URLSearchParams({ simulator_result: stringifiedValues });
                // navigate(`/simulator?${params}`);
                navigate(`/simulator?${params}`);
              }}        
            >
              <ChevronLeft width="18px" /> Modifier mes informations
              
            </div>

            <div 
              style={{ display: "flex", gap: "10px" ,alignItems: "center", cursor: "pointer", fontFamily: "var(--font-text)" }}
              onClick={() => {
                // window.location.reload();
                //const url = 'https://vefaa.bike/simulateur/'
                // window.open(url, '_self')
                // window.open(url)
                // navigate(`/simulator?${params}`);
                navigate(`/simulator`);
              }}        
            >
              <RefreshCw width="14px" /> Recommencer ma simulation
              
            </div>
          </Box>
          </Box>
          <Box
            col
            flexRatio={1}
            padding={{ inline_start:"m" }}
          >
            <Sections>
            <Section>
                <Heading weight="700" size="h4" marginY="m1">Votre trajet</Heading>
                <Box 
                  flex 
                  gap="no" 
                  rounded
                  all="m"
                  justifyContent="center"
                  border="gradient"
                >
                  <Box flexRatio={1} border="n-r-400">
                    <Text align="center" size="xs" marginY="m0">
                      Votre trajet actuel est de
                    </Text>

                    <Heading align="center">

                    <Box flex justifyContent="center" alignItems="baseline">
                      <AnimatedNumbers
                          transitions={(index) => ({
                            type: "spring",
                            duration: index + 0.3,
                          })}
                          animateToNumber={Math.floor(algo_result.distance / 1000)}
                          fontStyle={{
                            fontSize: "var(--font-size-xxxxxl)",
                          }}
                        />
                      km
                      </Box>
                    </Heading>
                    <Text align="center" size="xs" marginY="m0">
                      en voiture
                    </Text>
                  </Box>
                  <Box flexRatio={1} col>
                    <Text align="center" size="xs" marginY="m0">
                      ...soit environ
                    </Text>
                    <Heading align="center">
                      <Box flex justifyContent="center" alignItems="baseline">
                      <AnimatedNumbers
                          transitions={(index) => ({
                            type: "spring",
                            duration: index + 0.3,
                          })}
                          animateToNumber={Math.floor(algo_result.temps_trajet_velo)}
                          fontStyle={{
                            fontSize: "var(--font-size-xxxxxl)",
                          }}
                        />
                      min
                      </Box>
                    </Heading>
                    <Text align="center" size="xs" marginY="m0">
                      en vélo électrique
                    </Text>
                  </Box>
                </Box>
                <Box as="span" flex gap="xxs" justifyContent="end" alignItems="center">
                  <Text color="n-400" size="s">
                    👉 Découvrez votre itinéraire sécurisé en cliquant <a href={algo_result.url} target="_blank" style={{ color: 'var(--color-primary)' }}>ici</a> 
                  </Text>
                  <Image src={images.LogoGeoVelo} alt="Logo Géovélo" height="20px" />
                </Box>
              </Section>

              <Section>
                  <Heading weight="700" size="h4" marginY="m1" marginT="m0">Votre itinéraire à vélo</Heading>
                  <Box 
                    flex 
                    alignItems="center"
                    gap="no" 
                    rounded
                    all="xxs"
                    justifyContent="center"
                    border="gradient"
                    
                  >
                    <Box flexRatio={1}  border="n-r-400">
                      <Box flex justifyContent="space-around" alignItems="center" padding={"s"}>
                        <Image src={images.LogoGeoVelo} alt="Logo Géovélo" height="60px" />
                        <Text align="center" size="m" marginY="m0" paddingX="p2"  >
                          Découvrez votre itinéraire sécurisé en cliquant <a href={algo_result.url} target="_blank" style={{ color: 'var(--color-primary)' }}>ici</a> 
                        </Text>
                      </Box>
                    </Box>

                    <Box flexRatio={1} alignItems="center" col>

                      <a href={algo_result.url} target="_blank">
                        <Image src={images.map} alt="Map Géovélo" width="200px" height="150px" />
                      </a>
                    </Box>
                  </Box>
              </Section>

              <Section>
                <Heading weight="700" size="h4" marginY="m1" marginT="m1">Vos aides à l'achat</Heading>
                <Box
                  flex
                  gap="m"
                  rounded
                  all="m"
                  justifyContent="center"
                  border="gradient"
                >
                  <Box flexRatio={1} flex alignItems="center" justifyContent="center">
                    <Text size="l">Vous pouvez beneficier jusqu'à</Text>
                  </Box>
                  <StyledPieChart>
                    <Box as="span" flex justifyContent="center">
                      <Heading align="center" size="h2" weight="400">
                        {algo_result.aide_totale}€
                      </Heading>
                    </Box>
                    <PieChart width={140} height={140}>
                    <defs>
                        <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="0%" stopColor="var(--color-primary)" stopOpacity={1}/>
                            <stop offset="100%" stopColor="var(--color-light)" stopOpacity={1}/>
                        </linearGradient>
                    </defs>
                      <Pie
                        startAngle={-180-90}
                        // isAnimationActive={false}
                        data={[
                          {
                            value: algo_result.aide_totale - algo_result.aide_sc,
                            color: "red",
                          },
                          { value: algo_result.aide_sc },
                        ]}
                        innerRadius={50}
                        outerRadius={65}
                        paddingAngle={0}
                        dataKey="value"
                      >
                        <Cell key={`cell-0`} fill="var(--color-n-200)" />
                        <Cell
                          key={`cell-1`}
                          fill={"url(#colorUv)"}
                        />
                      </Pie>
                    </PieChart>
                  </StyledPieChart>
                  <Box flexRatio={1} flex alignItems="center" justifyContent="end">

                    {algo_result.aide_sc > 0 ? (
                      <Text align="center" size="l">
                        d'aide à l'achat dont <span style={{ fontWeight: "900", color: "var(--color-primary)" }}>{algo_result.aide_sc}€</span> d'aide sans
                        condition de revenu.
                      </Text>
                    ) : (
                      <div></div>
                    )}

                  </Box>
                </Box>
                <Box as="span" flex gap="xxxs" justifyContent="end" alignItems="center">
                  <Text color="n-400" size="s">
                  👉 Découvrez le détail de vos aides en cliquant <a href={`https://mesaidesvelo.fr/ville/${parsedFormValues.addresses.home.city?.toLowerCase()}?velo=%C3%A9lectrique`} target="_blank" style={{ color: 'var(--color-primary)' }}>ici</a> 
                  </Text>
                  <Image src={images.LogoMesAidesVelo} alt="Logo de mes aides velo" height="20px" />
                </Box>
              </Section>
              <Section>
                <Box flex gap="m" alignItems="center" padding={{block_end: "xs"}}>
                  <Heading weight="700" size="h4" marginY="m0">Vos économies</Heading>
                  <Box flex alignItems="center" >
                    <CustomToggleButtonGroup
                      value={isMonthly}
                      exclusive
                      size="small"
                      onChange={() => setIsMonthly(!isMonthly)}
                      aria-label="text alignment"
                    >
                      <CustomToggleButton 
                        value={true} 
                        aria-label="monthly"
                      >
                        <span>Par mois</span>
                      </CustomToggleButton>
                      <CustomToggleButton value={false} aria-label="yearly">
                        <span>Par an</span>
                      </CustomToggleButton>
                    </CustomToggleButtonGroup>
                  </Box>
                </Box>
                <Box 
                  flex 
                  gap="m" 
                  rounded
                  all="m"
                  justifyContent="center"
                  border="gradient"
                >
                  <Box flexRatio={1} col border="n-r-400">
                    <Box flex padding={{ inline_end: "s", inline_start: "s" }} justifyContent="space-between">
                      <div></div>
                      <Box flex justifyContent="center" alignItems="center" gap="xxs">
                        <Text align="center" size="xs" marginY="m0">
                          CO2
                        </Text>
                        <FaEarthAmericas  />
                      </Box>

                      <TooltipCustom
                        contentHtml={tooltipCo2Content}
                        color="var(--color-primary)"
                        fontSize={14}
                      />
                    </Box>
                      
                    <Heading align="center">
                      <Box flex justifyContent="center" alignItems="baseline">
                      <AnimatedNumbers
                          transitions={(index) => ({
                            type: "spring",
                            duration: index + 0.3,
                          })}
                          animateToNumber={Math.floor(polution)}
                          fontStyle={{
                            fontSize: "var(--font-size-xxxxxl)",
                          }}
                        />
                      kg
                      </Box>
                    </Heading>
                    <Text align="center" size="xs" marginY="m0">
                      de CO2 émis à l’usage économisés
                    </Text>
                  </Box>
                  <Box flexRatio={1} col>
                    <Box flex padding={{ inline_end: "s", inline_start: "s" }} justifyContent="space-between">
                      <div></div>
                      <Box flex justifyContent="center" alignItems="center" gap="xxs">
                        <Text align="center" size="xs" marginY="m0">
                          CARBURANT
                        </Text>
                        <FaGasPump />
                      </ Box>
                      <TooltipCustom
                        contentHtml={tooltipCarburantContent}
                        color="var(--color-primary)"
                        fontSize={14}
                      />
                    </Box>
                    <Heading align="center">

                      <Box flex justifyContent="center" alignItems="baseline">
                      <AnimatedNumbers
                          transitions={(index) => ({
                            type: "spring",
                            duration: index + 0.3,
                          })}
                          animateToNumber={Math.floor(savings)}
                          fontStyle={{
                            fontSize: "var(--font-size-xxxxxl)",
                          }}
                        />
                      €
                      </Box>

                    </Heading>
                    <Text align="center" size="xs" marginY="m0">
                      d’économies de carburant
                    </Text>
                  </Box>
                </Box>
              </Section>
              <Section>
                <Heading size="h5" align="center" marginY="m1">
                  <span style={{ fontWeight: "900", color: "var(--color-primary)", fontSize: "var(--font-size-xxxl)" }}>{Math.floor(polution)}kg</span> de CO2, c’est autant d’émission que pour fabriquer...
                </Heading>
                
                <Equivalents polution={polution} />
                <Box as="span" flex gap="xxs" justifyContent="end" alignItems="center">
                  <Text color="n-400" size="s">
                  👉 Découvrez d'autres équivalents CO2 en cliquant <a href="https://impactco2.fr/comparateur" target="_blank"  style={{ color: 'var(--color-primary)' }}>ici</a> 
                  </Text>
                  <Image src={images.ImpactCO2} alt="Logo impact C02" height="20px" />
                </Box>
              </Section>

              
              {(algo_result.aide_mobilite_durable > 0 || algo_result.aide_fonctionnaire > 0) && (
                <Section>
                  <Heading weight="700" size="h4" marginY="m1">Forfait Mobilité Durable</Heading>
                  <Box
                    flex
                    gap="xl"
                    rounded
                    all="m"
                    justifyContent="space-around"
                    alignItems="center"
                    border="gradient"
                  >
                    <Heading color="primary" weight="400" size="h6">

                    <Box flex justifyContent="center" alignItems="baseline">
                      <AnimatedNumbers
                          transitions={(index) => ({
                            type: "spring",
                            duration: index + 0.3,
                          })}
                          animateToNumber={ Math.round(algo_result.aide_mobilite_durable) > 0 ? Math.round(algo_result.aide_mobilite_durable) :  Math.round(algo_result.aide_fonctionnaire) }
                          fontStyle={{
                            fontSize: "var(--font-size-xxxxxl)",
                          }}
                        />
                      <span style={{ fontSize: "24px" }}>€</span>
                      </Box>                    
                    </Heading>
                    <Text maxWidth="300" size="s">
                      Ce que l’employeur vous versera, <span style={{ fontWeight: "900" }}>par an</span>, dans le cadre du Forfait Mobilité Durable
                    </Text>
                  </Box>
                  <Box as="span" flex gap="xxxs" justifyContent="end" alignItems="center">
                    <Text color="n-400" size="s">
                    👉 Découvrez le détail de vos aides en cliquant <a href={"https://mesaidesvelo.fr/forfait-mobilite-durable"} target="_blank"  style={{ color: 'var(--color-primary)' }}>ici</a> 
                    </Text>
                    <Image src={images.LogoMesAidesVelo} alt="Logo de mes aides velo" height="20px" />
                  </Box>
                </Section>
              )}

            </Sections>

            <Box padding="m">
              <Box flex justifyContent="center" gap="s">
                <Button color="secondary" 

                  onClick={() => {
                    const url = ' https://www.vefaa.bike/'
                    window.open(url, '_blank')
                    
                  }}
                >
                  découvrir notre vélo
                </Button>
                <Button color="primary">
                  <a href="#" onClick={() => {openTallyPopUp()}} >recevoir ma synthèse</a>
                </Button>
              </Box>
            </Box>

          </Box>
          </Box>
        ) : 
        <Box flex flexRatio={1} alignItems="center" gap="no" all="xxs">
          <div style={{ margin: "0 auto" }}>
          <Box>
          <Heading weight="700" size="h4" marginY="m1">Vos informations</Heading>
          <Box col border="gradient" rounded >
            <Sections>
              <Section> 
                <Heading weight="900" uppercase="true" size="h5" marginT="m1" paddingX="p1">Votre trajet</Heading>
                <hr style={{ width: "100%", border: "0.5px solid var(--color-n-200)", marginBottom: "0.5rem" }}/>
                <Box col gap="xxxs">
                  <Text styleText="italic" size="s" marginY="m0" color="n-400" paddingX="p1">Domicile</Text>
                  <Text marginY="m0" maxWidth="400" color="n-900" paddingX="p1">{parsedFormValues.addresses.home.label}</Text>
                  <Text styleText="italic" size="s" marginY="m0" color="n-400" paddingX="p1">Lieu de travail</Text>
                  <Text marginY="m0" maxWidth="400" color="n-900" paddingX="p1">{parsedFormValues.addresses.work.label}</Text>
                  <Text styleText="italic" size="s" marginY="m0" color="n-400" paddingX="p1">Fréquence</Text>
                  <Text marginY="m0" color="n-900"  paddingX="p1">
                    Vous effectuez le trajet <span style={{ fontWeight: "900", color: "var(--color-primary)" }}>{weeklyComute} fois</span> par semaine
                  </Text>
                  <Box padding="s">
                    <Formik
                      onSubmit={() => undefined}
                      initialValues={{ weekly_comutes: weeklyComute }}
                    >
                      {({ setFieldValue }) => (
                        <Form
                          onChange={(event) =>
                            handleWeeklyComuteChange(event, setFieldValue)
                          }
                        >
                          <TypePicker.Root fieldName="weekly_comutes">
                            <TypePicker.OptionsGroup direction="row" gap="xxxs">
                              {["1", "2", "3", "4", "5", "6", "7"].map((value) => (
                                <TypePicker.Option roundSmall={true} value={value}>
                                  {value}
                                </TypePicker.Option>
                              ))}
                            </TypePicker.OptionsGroup>
                          </TypePicker.Root>
                        </Form>
                      )}
                    </Formik>
                  </Box>
                </Box>
              </Section>
              <Section>
                <Heading weight="900" uppercase="true" size="h5" paddingX="p1">Votre véhicule</Heading>
                <hr style={{ width: "100%", border: "0.5px solid var(--color-n-200)", marginBottom: "0.5rem" }}/>
                <Box col gap="xxxs">
                  <Text styleText="italic" size="s" marginY="m0" color="n-400" paddingX="p1">Marque</Text>
                  <Text marginY="m0" color="n-900" paddingX="p1">{parsedFormValues.vehicle.brand}</Text>
                  <Text styleText="italic" size="s" marginY="m0" color="n-400" paddingX="p1">Modèle spécifique</Text>
                  <Text marginY="m0" color="n-900" paddingX="p1">{parsedFormValues.vehicle.model}</Text>
                  <Text styleText="italic" size="s" marginY="m0" color="n-400" paddingX="p1">Type de moteur</Text>
                  <Text marginY="m0" color="n-900" paddingX="p1">{parsedFormValues.vehicle.fuel}</Text>
                  <Text styleText="italic" size="s" marginY="m0" color="n-400" paddingX="p1">Année de mise en circulation</Text>
                    {parsedFormValues.vehicle.registrationYear !== "unknown" && (
                      <Text marginY="m0" color="n-900" paddingX="p1">{parsedFormValues.vehicle.registrationYear}</Text>
                    )}
                </Box>
              </Section>
              <Section>
                <Heading weight="900" uppercase="true" size="h5" paddingX="p1">Forfait Mobilité Durable</Heading>
                <hr style={{ width: "100%", border: "0.5px solid var(--color-n-200)", marginBottom: "0.5rem" }}/>
                <Box col gap="xxxs" padding={{ block_end: "s"}}>
                  
                  <Box padding="xs" flex alignItems="center" >
                    <CustomToggleButtonGroup
                      value={true}
                      exclusive
                      size="small"
                      onChange={() => ""}
                      aria-label="text alignment"
                    >


                      <CustomToggleButton 
                        value={maximalConditionalAmount > 0 ? true : false} 
                        disabled
                      >
                        <span>OUI</span>
                      </CustomToggleButton>
                      
                      <CustomToggleButton 
                        value={(maximalConditionalAmount === undefined || maximalConditionalAmount === 0) ? true : false}
                        disabled
                      >
                        <span>NON</span>
                      </CustomToggleButton>

                    </CustomToggleButtonGroup>
                  </Box>

                  <Text styleText="italic" size="s" marginY="m0" color="n-400" paddingX="p1">Montant maximal du forfait</Text>
                  <Text marginY="m0" color="n-900" paddingX="p1">{maximalConditionalAmount}€</Text>
                  
                  {/*

                  <Text style="italic" size="s" marginY="m0" color="n-400" paddingX="p1">Montant minimum du forfait</Text>
                  <Text marginY="m0" color="n-900" paddingX="p1">{algo_result.aide_totale}€</Text>
                  
                  */}
                  
                
                </Box>
              </Section>
            </Sections>
          </Box>
          <Box 
            flex 
            col
            justifyContent="start" 
            alignItems="center" 
            padding={{block_start: "s", block_end: "l"}} 
            gap="xxxs"
          >
            <div 
              style={{ display: "flex", gap: "6px" ,alignItems: "center", cursor: "pointer", fontFamily: "var(--font-text)" }}
              onClick={() => {
                const stringifiedValues = JSON.stringify(parsedFormValues);
                const params = new URLSearchParams({ simulator_result: stringifiedValues });
                // navigate(`/simulator?${params}`);
                navigate(`/simulator?${params}`);
              }}        
            >
              <ChevronLeft width="18px" /> Modifier mes informations
              
            </div>

            <div 
              style={{ display: "flex", gap: "10px" ,alignItems: "center", cursor: "pointer", fontFamily: "var(--font-text)" }}
              onClick={() => {
                navigate(`/simulator`);
              }}        
            >
              <RefreshCw width="14px" /> Recommencer ma simulation
              
            </div>
          </Box>
            </Box>
            <Box
              col
              flexRatio={1}
            >
              <Sections>
                <Section>
                  <Heading weight="700" size="h4" marginY="m1" marginT="m2">Votre trajet</Heading>
                  <Box 
                    flex 
                    gap="no" 
                    rounded
                    all="m"
                    justifyContent="center"
                    border="gradient"
                    
                  >
                    <Box flexRatio={1} border="n-r-400">
                      <Text align="center" size="xs" marginY="m0">
                        Votre trajet actuel est de
                      </Text>

                      <Heading align="center">

                      <Box flex justifyContent="center" alignItems="baseline">
                        <AnimatedNumbers
                            transitions={(index) => ({
                              type: "spring",
                              duration: index + 0.3,
                            })}
                            animateToNumber={Math.floor(algo_result.distance / 1000)}
                            fontStyle={{
                              fontSize: "var(--font-size-xxxxxl)",
                            }}
                          />
                        km
                        </Box>
                      </Heading>
                      <Text align="center" size="xs" marginY="m0">
                        en voiture
                      </Text>
                    </Box>
                    <Box flexRatio={1} col>
                      <Text align="center" size="xs" marginY="m0">
                        ...soit environ
                      </Text>
                      <Heading align="center">
                        <Box flex justifyContent="center" alignItems="baseline">
                        <AnimatedNumbers
                            transitions={(index) => ({
                              type: "spring",
                              duration: index + 0.3,
                            })}
                            animateToNumber={Math.floor(algo_result.temps_trajet_velo)}
                            fontStyle={{
                              fontSize: "var(--font-size-xxxxxl)",
                            }}
                          />
                        min
                        </Box>
                      </Heading>
                      <Text align="center" size="xs" marginY="m0">
                        en vélo électrique
                      </Text>
                    </Box>
                  </Box>
                  <Box as="span" flex gap="xxs" justifyContent="end" alignItems="center" >
                    <Text color="n-400" size="s">
                      👉 Découvrez votre itinéraire sécurisé en cliquant <a href={algo_result.url} target="_blank" style={{ color: 'var(--color-primary)' }}>ici</a> 
                    </Text>
                    <Image src={images.LogoGeoVelo} alt="Logo Géovélo" height="20px" />
                  </Box>
                </Section>

                <Section>
                  <Heading weight="700" size="h4" marginY="m1" marginT="m2">Votre itinéraire à vélo</Heading>
                  <Box 
                    flex 
                    alignItems="center"
                    gap="no" 
                    rounded
                    all="m"
                    justifyContent="center"
                    border="gradient"
                    
                  >
                    <Box flexRatio={1}  >
                      <Box flex justifyContent="space-around" alignItems="center" padding={"s"}>
                        <Image src={images.LogoGeoVelo} alt="Logo Géovélo" height="40px" />
                        <Text align="center" size="xs" marginY="m0" paddingX="p2"  >
                          Découvrez votre itinéraire sécurisé en cliquant <a href={algo_result.url} target="_blank" style={{ color: 'var(--color-primary)' }}>ici</a> 
                        </Text>
                      </Box>
                    </Box>
                  </Box>
                </Section>

                <Section>
                  <Heading weight="700" size="h4" marginT="m2" marginY="m1">Vos aides à l'achat</Heading>
                  <Box
                    flex
                    gap="m"
                    rounded
                    all="m"
                    justifyContent="center"
                    border="gradient"
                  >
                    <Box flexRatio={1} flex alignItems="center" justifyContent="center">
                      <Text size="s">Vous pouvez beneficier jusqu'à</Text>
                    </Box>
                    <StyledPieChart>
                      <Box as="span" flex justifyContent="center">
                        <Heading align="center" size="h2" weight="400">
                          {algo_result.aide_totale}€
                        </Heading>
                      </Box>
                      <PieChart width={140} height={140}>
                      <defs>
                          <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                              <stop offset="0%" stopColor="var(--color-primary)" stopOpacity={1}/>
                              <stop offset="100%" stopColor="var(--color-light)" stopOpacity={1}/>
                          </linearGradient>
                      </defs>
                        <Pie
                          startAngle={-180-90}
                          // isAnimationActive={false}
                          data={[
                            {
                              value: algo_result.aide_totale - algo_result.aide_sc,
                              color: "red",
                            },
                            { value: algo_result.aide_sc },
                          ]}
                          innerRadius={50}
                          outerRadius={65}
                          paddingAngle={0}
                          dataKey="value"
                        >
                          <Cell key={`cell-0`} fill="var(--color-n-200)" />
                          <Cell
                            key={`cell-1`}
                            fill={"url(#colorUv)"}
                          />
                        </Pie>
                      </PieChart>
                    </StyledPieChart>
                    <Box flexRatio={1} flex alignItems="center" justifyContent="end">

                      {algo_result.aide_sc > 0 ? (
                        <Text align="center" size="s">
                          d'aide à l'achat dont <span style={{ fontWeight: "900", color: "var(--color-primary)" }}>{algo_result.aide_sc}€</span> d'aide sans
                          condition de revenu.
                        </Text>
                      ) : (
                        <div></div>
                      )}

                    </Box>
                  </Box>
                  <Box as="span" flex gap="xxxs" justifyContent="end" alignItems="center">
                    <Text color="n-400" size="s">
                    👉 Découvrez le détail de vos aides en cliquant <a href={`https://mesaidesvelo.fr/ville/${parsedFormValues.addresses.home.city?.toLowerCase()}?velo=%C3%A9lectrique`} target="_blank" style={{ color: 'var(--color-primary)' }}>ici</a> 
                    </Text>
                    <Image src={images.LogoMesAidesVelo} alt="Logo de mes aides velo" height="20px" />
                  </Box>
                </Section>
                <Section>
                  <Box flex gap="m" alignItems="center" padding={{block_end: "xs"}}>
                    <Heading weight="700" size="h4" marginY="m0" marginT="m2">Vos économies</Heading>
                    <Box padding={{block_start:"xl"}} flex alignItems="center" >
                      <CustomToggleButtonGroup
                        value={isMonthly}
                        exclusive
                        size="small"
                        onChange={() => setIsMonthly(!isMonthly)}
                        aria-label="text alignment"
                      >
                        <CustomToggleButton 
                          value={true} 
                          aria-label="monthly"
                        >
                          <span>Par mois</span>
                        </CustomToggleButton>
                        <CustomToggleButton value={false} aria-label="yearly">
                          <span>Par an</span>
                        </CustomToggleButton>
                      </CustomToggleButtonGroup>
                    </Box>
                  </Box>
                  <Box 
                    flex 
                    gap="m" 
                    rounded
                    all="m"
                    justifyContent="center"
                    border="gradient"
                  >
                    <Box flexRatio={1} col >
                      <Box flex padding={{ inline_end: "s", inline_start: "s" }} justifyContent="space-between">
                        <div></div>
                        <Box flex justifyContent="center" alignItems="center" gap="xxs">
                          <Text align="center" size="xs" marginY="m0">
                            CO2
                          </Text>
                          <FaEarthAmericas  />
                        </Box>

                        <TooltipCustom
                          contentHtml={tooltipCo2Content}
                          color="var(--color-primary)"
                          fontSize={14}
                        />
                      </Box>
                        
                      <Heading align="center">
                        <Box flex justifyContent="center" alignItems="baseline">
                        <AnimatedNumbers
                            transitions={(index) => ({
                              type: "spring",
                              duration: index + 0.3,
                            })}
                            animateToNumber={Math.floor(polution)}
                            fontStyle={{
                              fontSize: "var(--font-size-xxxl)",
                            }}
                          />
                        kg
                        </Box>

                      </Heading>
                      <Text align="center" size="xs" marginY="m0">
                        de CO2 émis à l’usage économisés
                      </Text>
                    </Box>
                    <Box flexRatio={1} col>
                      <Box flex padding={{ inline_end: "s", inline_start: "s" }} justifyContent="space-between">
                        <div></div>
                        <Box flex justifyContent="center" alignItems="center" gap="xxs">
                          <Text align="center" size="xs" marginY="m0">
                            CARBURANT
                          </Text>
                          <FaGasPump />
                        </ Box>
                        <TooltipCustom
                          contentHtml={tooltipCarburantContent}
                          color="var(--color-primary)"
                          fontSize={14}
                        />
                      </Box>
                      <Heading align="center">

                        <Box flex justifyContent="center" alignItems="baseline">
                        <AnimatedNumbers
                            transitions={(index) => ({
                              type: "spring",
                              duration: index + 0.3,
                            })}
                            animateToNumber={Math.floor(savings)}
                            fontStyle={{
                              fontSize: "var(--font-size-xxxl)",
                            }}
                          />
                        €
                        </Box>

                      </Heading>
                      <Text align="center" size="xs" marginY="m0">
                        d’économies de carburant
                      </Text>
                    </Box>
                  </Box>
                </Section>
                <Section>
                  <Heading size="h5" align="center" marginY="m1" marginT="m2">
                    <span style={{ fontWeight: "900", color: "var(--color-primary)", fontSize: "var(--font-size-xxxl)" }}>{Math.floor(polution)}kg</span> de CO2, c’est autant d’émission que pour fabriquer...
                  </Heading>
                  
                  <Equivalents polution={polution} />
                  <Box as="span" flex gap="xxs" justifyContent="end" alignItems="center">
                    <Text color="n-400" size="s">
                    👉 Découvrez d'autres équivalents CO2 en cliquant <a href="https://impactco2.fr/comparateur" target="_blank"  style={{ color: 'var(--color-primary)' }}>ici</a> 
                    </Text>
                    <Image src={images.ImpactCO2} alt="Logo impact C02" height="20px" />
                  </Box>
                </Section>

                
                {(algo_result.aide_mobilite_durable > 0 || algo_result.aide_fonctionnaire > 0) && (
                  <Section>
                    <Heading weight="700" size="h4" marginY="m1">Forfait Mobilité Durable</Heading>
                    <Box
                      flex
                      gap="xl"
                      rounded
                      all="m"
                      justifyContent="space-around"
                      alignItems="center"
                      border="gradient"
                    >
                      <Heading color="primary" weight="400" size="h6">

                      <Box flex justifyContent="center" alignItems="baseline">
                        <AnimatedNumbers
                            transitions={(index) => ({
                              type: "spring",
                              duration: index + 0.3,
                            })}
                            animateToNumber={ Math.round(algo_result.aide_mobilite_durable) > 0 ? Math.round(algo_result.aide_mobilite_durable) :  Math.round(algo_result.aide_fonctionnaire) }
                            fontStyle={{
                              fontSize: "var(--font-size-xxxxl)",
                            }}
                          />
                        <span style={{ fontSize: "24px" }}>€</span>
                        </Box>                    
                      </Heading>
                      <Text maxWidth="300" size="s">
                        Ce que l’employeur vous versera, <span style={{ fontWeight: "900" }}>par an</span>, dans le cadre du Forfait Mobilité Durable
                      </Text>
                    </Box>
                    <Box as="span" flex gap="xxxs" justifyContent="end" alignItems="center">
                      <Text color="n-400" size="s">
                      👉 Découvrez le détail de vos aides en cliquant <a href={"https://mesaidesvelo.fr/forfait-mobilite-durable"} target="_blank"  style={{ color: 'var(--color-primary)' }}>ici</a> 
                      </Text>
                      <Image src={images.LogoMesAidesVelo} alt="Logo de mes aides velo" height="20px" />
                    </Box>
                  </Section>
                )}

              </Sections>

              <Box padding="m">
                <Box col flex justifyContent="center" alignItems="center" gap="s">
                  <Button color="secondary" 

                    onClick={() => {
                      const url = ' https://www.vefaa.bike/'
                      window.open(url, '_blank')
                      
                    }}
                  >
                    découvrir notre vélo
                  </Button>
                  <Button color="primary">
                    <a href="#" onClick={() => {openTallyPopUp()}} >recevoir ma synthèse</a>
                  </Button>
                </Box>
              </Box>

            </Box>
          </div>
          
        </Box>
    }
        
    </Box>
  );
};

const Result = () => {
  const { algo_result,  request_id, form_values} = useParams() as { form_values: string, algo_result: string, request_id: string};
  const parsedFormValues = JSON.parse(form_values) as FormValues;
  const parsedAlgoResult = JSON.parse(algo_result) as ResultResponse;

  return (
    <Box flexRatio={1} col>
      <Box flexRatio={1} col>
        <LoadedComponent
          parsedFormValues={parsedFormValues}
          algo_result={parsedAlgoResult}
          request_id={request_id}
        />
      </Box>
    </Box>
  );
};

export { Result };
